import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { trackMxEvent } from '@/utils/mixpanel'
import useAuth from '@/hooks/useAuth'
import PageLoader from '@/components/pageloader'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import HeaderMenu from './header-menu'
import HeaderMobileMenu from './mobile-menu'
import NotificationMenu from './notification-menu'
import UserMenu from './user-menu'

type Props = {
  hideLogin?: boolean
}

const Header = ({ hideLogin = false }: Props) => {
  const { isLoggedin, maybeLoggedin } = useAuth()
  const router = useRouter()
  const returnTo = encodeURIComponent(router.asPath)

  return (
    <nav className="sticky top-0 z-50 bg-background/80 backdrop-blur-lg">
      <div className="container flex h-18 w-full items-center justify-between px-4 md:px-5">
        <HeaderMobileMenu />
        <div className="flex max-w-4xl flex-1 items-center gap-4">
          <Link href="/" className="block leading-none">
            <Image
              className="hidden h-8 w-40 dark:inline-block"
              src="/images/logo-inverse.svg"
              alt="ONLIVE.studio logo"
              width="160"
              height="32"
              loading="eager"
            />
            <Image
              className="h-8 w-40 dark:hidden"
              src="/images/logo.svg"
              alt="ONLIVE.studio logo"
              width="160"
              height="32"
              loading="eager"
            />
          </Link>
          <div className="hidden lg:block">
            <HeaderMenu />
          </div>
        </div>
        <div className="flex items-center gap-2">
          {!hideLogin && (
            <div className="hidden items-center md:flex md:gap-4">
              {!isLoggedin && !maybeLoggedin && (
                <>
                  <Button variant="ghost" asChild>
                    <Link
                      href={`/signin?return_to=${returnTo}`}
                      onClick={() => trackMxEvent('Header Signin Click')}
                    >
                      ログイン
                    </Link>
                  </Button>
                  <Button
                    variant="primary-outline"
                    asChild
                    className="hidden lg:inline-flex"
                  >
                    <Link
                      href={`/signup?return_to=${returnTo}`}
                      onClick={() => trackMxEvent('Header Signup Click')}
                    >
                      アカウント登録
                    </Link>
                  </Button>
                </>
              )}
            </div>
          )}
          {maybeLoggedin && (
            <>
              <Skeleton className="h-9 w-9 rounded-full" />
              <Skeleton className="h-12 w-12 rounded-full" />
            </>
          )}
          {isLoggedin && (
            <>
              <NotificationMenu />
              <UserMenu />
            </>
          )}
          {!isLoggedin && (
            <Button variant="ghost" className="px-2 md:hidden" asChild>
              <Link
                href={`/signin?return_to=${returnTo}`}
                onClick={() => trackMxEvent('Header Signin Click')}
              >
                ログイン
              </Link>
            </Button>
          )}
        </div>
      </div>
      <PageLoader />
    </nav>
  )
}

export default Header
